export enum EtablissementFichierType {
  DECLARATION = 'DECLARATION',
  ATTESTATION = 'ATTESTATION',
  ALERTES = 'ALERTES',
}

export const ALL_ETABLISSEMENT_FICHIER_TYPES: EtablissementFichierType[] = [
  EtablissementFichierType.DECLARATION,
  EtablissementFichierType.ATTESTATION,
  EtablissementFichierType.ALERTES,
];